<!--
 * @Author: mzw
 * @Date: 2021-09-23 10:25:34
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-08-20 10:30:41
 * @Description: 商品列表组件
-->
<template>
  <div class="product-box">
    <el-col :span="24">
      <el-table
        ref="goodsTable"
        :data="productData"
        size="small"
        :header-cell-style="{ background: '#f9f9f9' }"
        :span-method="isOperation ? objectSpanMethod : null"
      >
        <!-- <el-table-column type="index" width="50" align="center"></el-table-column> -->
        <el-table-column
          prop="img"
          label=""
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <div class="imgBox">
              <img
                :src="scope.row.goodsUrl"
                v-show="scope.row.goodsUrl"
                alt=""
                width="80px"
                height="80px"
              />
              <img
                src="~@/assets/img/bitmap.png"
                v-show="!scope.row.goodsUrl"
                alt=""
                width="80px"
                height="80px"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('order.productInfo2')" width="200">
          <template slot-scope="scope">
            <div class="product-info" @click.stop="goodDetail(scope.row)">
              <p>{{ scope.row.goodsName }}</p>
              <span>{{$t('product.codes')}}：{{ scope.row.goodsCode }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="brandName" :label="$t('common.brand')"></el-table-column>
        <el-table-column
          prop="goodsModel"
          :label="$t('common.model')"
          width="110"
        ></el-table-column>
        <el-table-column :label="$t('order.unitPrice')" width="90">
          <template slot-scope="scope">
            <span
              v-if="showOriginal"
              :label="scope.row.originalTransactionPrice"
              >{{
                scope.row.originalTransactionPrice
                  ? scope.row.originalTransactionPrice.toFixed(2)
                  : '0.00'
              }}</span
            >
            <span v-else :label="scope.row.sellingPrice">{{
              scope.row.sellingPrice
                ? scope.row.sellingPrice.toFixed(2)
                : '0.00'
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsNum"
          :label="$t('common.quantity')"
          :width="isSelection ? 130 : 70"
        >
          <template slot-scope="scope">
            <span v-if="!isSelection">{{ scope.row.goodsNum }}</span>
            <!-- <el-tooltip
              v-else
              placement="top"
              :content="`起订量${scope.row.moq || 1}, 步长${
                scope.row.sellingUnitStepSize || 1
              }`"
            > -->
            <el-input-number
              v-else
              @change="numberChange"
              style="width: 100%"
              size="small"
              :disabled="loading"
              v-model="scope.row.goodsNum"
              :step="1"
              :min="0"
              :max="999999999"
              :precision="0"
            ></el-input-number>
            <!-- </el-tooltip> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsUnit"
          :label="$t('common.unit')"
          width="70"
        ></el-table-column>
        <el-table-column prop="logisticsTemplate" :label="$t('order.term')" width="130">
          <template slot-scope="scope">
            {{ scope.row.logisticsTemplate }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('order.lineTotal')" width="130">
          <template slot-scope="scope">
            <span :label="scope.row.goodsMoney" class="sign-text">{{
              scope.row.goodsMoney ? scope.row.goodsMoney.toFixed(2) : '0.00'
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('order.handle')"
          width="130"
          class-name="merge-item"
          v-if="isOperation"
        >
          <template slot-scope="scope">
            <span :label="scope.row.deliveryStatus" class="status-tip">{{
              scope.row.deliveryStatusText || '-'
            }}</span>
            <span
              class="blue-tip"
              v-if="['已发货', '已签收'].includes(scope.row.deliveryStatusText) && scope.row.logisticsNumber"
              @click.stop="getLogisticsList(scope.row)"
              >{{$t('product.logistics')}}</span
            >
            <span
              class="blue-tip"
              v-if="
                !['10', '90'].includes(orderStatus)
              "
              @click.stop="afterSales(scope.row)"
              >{{$t('product.afterSale')}}</span
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 商品分页 -->
      <el-pagination
        layout="prev, pager, next"
        v-show="isPage && productList && productList.length > pageNum"
        :current-page="goodsPage"
        :page-size="pageNum"
        :total="productList ? productList.length : 0"
        @current-change="changeGoodsPage"
      >
      </el-pagination>
    </el-col>
    <el-dialog title="申请售后" :visible.sync="applySalesVisible" width="860px">
      <ApplySales
        v-if="applySalesVisible"
        @cancel="applySalesVisible = false"
        @success="applySalesVisible = false"
        :row="row"
      ></ApplySales>
    </el-dialog>
  </div>
</template>
<script>
import ApplySales from '@/components/applySales/applySales.vue'

export default {
  components: {
    ApplySales
  },
  data () {
    return {
      loading: false,
      applySalesVisible: false
    }
  },
  props: {
    productList: {
      type: Array,
      default: () => {
        return []
      }
    },
    isPage: {
      // 是否分页
      type: Boolean,
      default: false
    },
    goodsPage: {
      // 第几页
      type: Number
    },
    pageNum: {
      // 每页几条
      type: Number
    },
    isSelection: {
      // 是否是选型询价
      type: Boolean,
      default: false
    },
    isOperation: {
      // 是否有操作/状态栏
      type: Boolean,
      default: false
    },
    showOriginal: {
      // 是否显示后台成交单价
      type: Boolean,
      default: false
    },
    orderStatus: {
      type: String,
      default: ''
    }
  },
  computed: {
    productData () {
      if (this.isPage) {
        return (this.productList || []).slice(
          (this.goodsPage - 1) * this.pageNum,
          this.goodsPage * this.pageNum
        )
      } else {
        return this.productList || []
      }
    }
  },
  watch: {
    productData: {
      handler (n, o) {
        if (this.isOperation) {
          this.getSpanArr(this.productData)
        }
      },
      immediate: true
    }
  },
  methods: {
    // 选型询价商品数量修改，同步修改外部价格数量
    numberChange () {
      this.$emit('numberChange')
    },
    changeGoodsPage (page) {
      this.$emit('changeGoodsPage', page)
    },
    goodDetail (row) {
      this.$emit('goodDetail', row)
    },
    getLogisticsList (row) {
      this.$emit('getLogisticsList', row)
    },
    afterSales (row) {
      const obj = {
        orderId: row.orderId,
        goodsSkuId: row.goodsSkuId
      }
      this.$http
        .post('/front/webshop/lclb/userAfterSales/getAddInfo', obj)
        .then(({ data: res }) => {
          if (res.code === 0) {
            // 如果有申请历史就缓存下来
            if (res.data) {
              this.row = {
                ...row,
                ...res.data
              }
              this.applySalesVisible = true
            }
          }
        })
    },
    // afterSalesDetail (row) {
    //   this.$router.push({
    //     path: '/personalCenter/afterSalesDetail',
    //     query: {
    //       userAfterSalesCode: row.userAfterSalesCode
    //     }
    //   })
    // },
    // 合并行
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // columnIndex === xx 找到第xx列，实现合并随机出现的行数
      // if (columnIndex === 8) {
      //   const _row = this.spanArr[rowIndex]
      //   const _col = _row > 0 ? 1 : 0
      //   return {
      //     rowspan: _row,
      //     colspan: _col
      //   }
      // }
    },
    // 因为要合并的行数是不固定的，此函数是实现合并随意行数的功能
    getSpanArr (data) {
      console.log('zmmm--', data) // 从后台获取的数据
      this.spanArr = []
      this.pos = 0
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          // 如果是第一条记录（即索引是0的时候），向数组中加入１
          this.spanArr.push(1)
          this.pos = 0
        } else {
          // if (data[i].itemCode === data[i - 1].itemCode || data[i].itemName === data[i - 1].itemName) {
          if (data[i].deliveryCode === data[i - 1].deliveryCode &&
            data[i].deliveryCode) {
            // 如果itemCode相等就累加，并且push 0
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            // 不相等push 1
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../common/productStyle.scss';
/deep/ .merge-item {
  border-left: 1px solid #ebeef5;
  .cell {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
